<template>
  <Modal ref="confirmationModal"
         title-class="h1"
         :title="title"
         :size="size"
         :no-close-on-backdrop="true"
         :hide-header-close="hideHeaderClose"
         :no-enforce-focus="true"
         :hide-header="hideHeader"
         :static="true"
         @hidden="onHidden"
         @hide="hide">
    <slot name="body">
      <p v-if="isMessageHtml"
         v-html="sanitizedMessage"></p>
      <p v-else>{{ message }}</p>
    </slot>
    <template #modal-footer>
      <div>
        <slot name="footer"
              :ok="ok"
              :hide="hide">
          <ConfirmationModalButtonGroup @ok="ok()"
                                        @cancel="hide()"></ConfirmationModalButtonGroup>
        </slot>
      </div>
    </template>
  </Modal>
</template>

<script>
  import purify from 'dompurify';
  import ConfirmationModalButtonGroup from './ConfirmationModalButtonGroup.vue';
  import BootstrapVariant from '~/zf/frontend/vendor/bootstrap/BootstrapVariant';
  import Modal from './Modal.vue';

  /*
    [Vue migration] Developer Note
    This component has a twin version for both Vue 2 and Vue 3 projects.
    When making changes, remember to update and test both versions.
  */
  export default {
    name: 'ConfirmationModal',
    compatConfig: {
      MODE: 3,
    },
    components: { Modal, ConfirmationModalButtonGroup },
    props: {
      isMessageHtml: {
        type: Boolean,
        default: false,
      },
      message: {
        type: String,
        required: true,
      },
      title: {
        type: String,
        required: false,
      },
      hideHeaderClose: {
        type: Boolean,
        default: false,
        required: false,
      },
      size: {
        default: BootstrapVariant.SMALL,
      },
    },
    emits: ['ok'],
    data() {
      return {
        BootstrapVariant,
        resolve: null,
        isDisabled: false,
      };
    },
    computed: {
      hideHeader() {
        if (this.title) {
          return false;
        }
        return true;
      },
      sanitizedMessage() {
        return purify.sanitize(this.message);
      },
    },
    methods: {
      show() {
        this.$refs.confirmationModal.show();
      },
      confirm() {
        this.$refs.confirmationModal.show();
        return new Promise((resolve) => {
          this.resolve = resolve;
        });
      },
      onHidden() {
        this.isDisabled = false;
      },
      hide() {
        if (this.resolve !== null) {
          this.resolve(false);
        }
        this.$refs.confirmationModal.hide();
      },
      ok() {
        if (this.isDisabled) {
          return;
        }
        this.isDisabled = true;

        this.$emit('ok');
        if (this.resolve !== null) {
          this.resolve(true);
        }
        this.$refs.confirmationModal.hide();
      },
    },
  };
</script>
